import PurposesParagraph from './PurposesParagraph'

export default PurposesParagraph
